import type { Theme } from '@emotion/react';
import { buildTheme } from 'common-ui';
import merge from 'lodash/merge';
import type { CommonThemeVars, ThemeCreateFunction } from 'tsconfig/types';
import { buildThemeVarsAPACAdc, buildThemeMixinsAPACAdc, buildThemeWidgetStylesAPACAdc } from 'dw-apac-adc/theme';

const createTheme: ThemeCreateFunction = () =>
  buildTheme(
    (vars: Pick<Theme, CommonThemeVars>) => merge({}, buildThemeVarsAPACAdc(vars)),
    (vars: Omit<Theme, 'mixins' | 'widgets'>) => buildThemeMixinsAPACAdc(vars),
    (vars: Omit<Theme, 'widgets'>) => buildThemeWidgetStylesAPACAdc(vars),
  );


export default createTheme;
